/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class EquipmentTemplate {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.fields = [];
            this.parts = [];
            this.alarmCodeIds = [];
        }
    }

    /**
     * Adds a field in this equipment template.
     *
     * @param {EquipmentTemplateField} field Field.
     * @return {Boolean} True if the field was added, false if there's already another field with the same name.
     */
    addField(field) {
        const duplicated = this.fields.find(existingField => field.name === existingField.name);
        if (!duplicated) {
            this.fields.push(field);
        }
        return !duplicated;
    }

    /**
     * Adds a part in this equipment template.
     *
     * @param {String} name Part name.
     * @return {Boolean} True if the part was added, false if there's already another part with the same name.
     */
    addPart(name) {
        const duplicated = this.parts.find(existingPart => name === existingPart.name);
        if (!duplicated) {
            this.parts.push({name});
        }
        return !duplicated;
    }

    /**
     * Removes a field from this equipment template.
     *
     * @param {EquipmentFielTemplate} field Field.
     * @return {Boolean} True if the field has been removed, false it was not found.
     */
    removeField(field) {
        const index = this.fields.indexOf(field);
        if (index > -1) {
            this.fields.splice(index, 1);
        }
        return (index > -1);
    }

    /**
     * Removes a part from this equipment template.
     *
     * @param {String} Part name.
     */
    removePart(part) {
        const index = this.parts.indexOf(part);
        if (index > -1) {
            this.parts.splice(index, 1);
        }
    }
}

export { EquipmentTemplate };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/EquipmentTemplate.js